import { audio } from '../systems/audio/AudioSystem.js';
import { ACTS, isActUnlocked } from '../data/acts.js';

/**
 * Where a run begins (data/acts.js). Sits between Play and champion select.
 *
 * The three routes are the same kind of thing now, which is the whole point of
 * the split: three standalone acts, each with its own bosses, its own rewards,
 * its own leaderboard board and its own ending. Act I is simply the one that
 * starts open; each later act is unlocked by beating the one before it. There
 * is no longer a practice route to caveat, so the screen can stop apologising
 * for two of its three cards.
 *
 * A locked act shows as locked rather than being hidden, but deliberately says
 * nothing about what's down there — the name alone is as far as the spoiler
 * goes before the run that earns it.
 */
export class ActSelect {
  constructor(root, save, { onPick, onBack }) {
    this.root = root;
    this.save = save;
    this.onPick = onPick;
    this.onBack = onBack;
    this.el = document.createElement('div');
    this.el.className = 'menu-overlay act-select-overlay';
    this._render();
    this.root.appendChild(this.el);
  }

  _render() {
    this.el.innerHTML = `
      <div class="menu-kicker">CAMPAIGN</div>
      <div class="menu-title">WHERE TO BEGIN</div>
      <div class="menu-subtitle">Three acts, each its own run. Finish one to open the next.</div>
    `;

    const cards = document.createElement('div');
    cards.className = 'play-menu-cards act-select-cards';
    for (const act of ACTS) cards.appendChild(this._buildCard(act));
    this.el.appendChild(cards);

    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'menu-button';
    back.textContent = 'Back';
    back.addEventListener('click', () => { audio.playSfx('click'); this.onBack(); });
    this.el.appendChild(back);
  }

  _buildCard(act) {
    const unlocked = isActUnlocked(act, this.save.statistics);
    const card = document.createElement('button');
    card.type = 'button';
    card.className = `menu-button play-mode-card${act.startIndex === 0 ? ' play-mode-card-primary' : ''}`;
    card.disabled = !unlocked;
    // Every locked act is gated on *beating* the act before it, not on reaching
    // it (see isActUnlocked) — so the locked copy says which bar it is without
    // naming what's behind it. Deliberately identical for both: the shape of
    // the gate is the same, and the difference is only which act you're on.
    const blurb = unlocked ? act.blurb : 'Locked — finish the act before this one to unlock it.';
    // ▶ the act that starts open, ▼ the descent, ♪ the song that follows it.
    const icon = act.startIndex === 0 ? '▶' : (act.id === 'act3' ? '♪' : '▼');
    card.innerHTML = `
      <span class="play-mode-icon">${unlocked ? icon : '🔒'}</span>
      <span><b>${act.name}</b><small>${blurb}</small></span>
    `;
    if (unlocked) {
      card.addEventListener('click', () => { audio.playSfx('click'); this.onPick(act.startIndex); });
    }
    return card;
  }

  destroy() {
    this.el.remove();
  }
}
